import React from 'react';
import clsx from 'clsx';
import styles from '../index.module.scss';

interface VideoDisplayProps {
  src: string;
  className?: string;
}

export default function VideoDisplay({ src, className }: VideoDisplayProps) {
  // const vidRef = useRef<HTMLVideoElement | null>(null);

  return (
    <video
      controls
      controlsList="nodownload"
      src={src}
      preload="metadata"
      onClick={(e) => e.stopPropagation()}
      className={clsx(styles.videoContent, className)}
    >
      <track kind="captions" />
    </video>
  );
}
